// Format monetaire quebecois (fr-CA / CAD) : "1 234,56 $"
// Symbole a la fin, espace insecable comme separateur de milliers, virgule decimale.
// `decimals` permet de conserver les endroits qui affichent 0 decimale (ex. KPI dashboard).
export const formatCurrency = (value, decimals = 2) => {
  const number = Number(value) || 0;
  return new Intl.NumberFormat('fr-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })?.format(number);
};
